<template>
  <div class="content__actions">
    <div class="checkout" style="height: auto;">
      <div class="checkout__info" @click="toggleQRCode">
        <canvas ref="qrcodeCanvas" v-show="code"></canvas>
        <div class="info__recipient">
          <div><p class="recipient__title">收款人钱包地址</p>
            <div class="recipient__address"><span class="address__text">{{token.tokenAddress}}</span>
              <div class="address__buttons">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click.stop="generateQRCode">
                  <path d="M16 17V16H13V13H16V15H18V17H17V19H15V21H13V18H15V17H16ZM21 21H17V19H19V17H21V21ZM3 3H11V11H3V3ZM5 5V9H9V5H5ZM13 3H21V11H13V3ZM15 5V9H19V5H15ZM3 13H11V21H3V13ZM5 15V19H9V15H5ZM18 13H21V15H18V13ZM6 6H8V8H6V6ZM6 16H8V18H6V16ZM16 6H18V8H16V6Z" fill="currentColor"></path>
                </svg>
                <button class="address__copy_btn" @click.stop="copy">
                  <svg width="17" height="16" viewBox="0 0 17 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.82961 6.92431e-07L8.86815 4.05779e-06H11.8028L11.8413 6.92431e-07H11.8414H11.8414C12.3685 -1.47793e-05 12.8233 -2.81246e-05 13.1978 0.0305736C13.5931 0.0628745 13.9864 0.13419 14.3647 0.326985C14.9292 0.614605 15.3882 1.07355 15.6758 1.63803C15.8686 2.01641 15.9399 2.40963 15.9722 2.80498C16.0028 3.17955 16.0028 3.63432 16.0028 4.16148V4.2V8.30206V8.34058C16.0028 8.86774 16.0028 9.32251 15.9722 9.69709C15.9399 10.0924 15.8686 10.4857 15.6758 10.864C15.3882 11.4285 14.9292 11.8875 14.3647 12.1751C13.9864 12.3679 13.5931 12.4392 13.1978 12.4715C12.9447 12.4922 12.655 12.4989 12.331 12.501C12.3337 12.2946 12.3336 12.0809 12.3336 11.8648L12.3336 11.801V10.5009C12.6268 10.4988 12.8498 10.4933 13.0349 10.4781C13.3066 10.4559 13.4073 10.4183 13.4568 10.3931C13.6449 10.2972 13.7979 10.1442 13.8938 9.95605C13.919 9.9066 13.9566 9.80589 13.9788 9.53422C14.002 9.25088 14.0028 8.87861 14.0028 8.30206V4.2C14.0028 3.62345 14.002 3.25118 13.9788 2.96784C13.9566 2.69618 13.919 2.59546 13.8938 2.54601C13.7979 2.35785 13.6449 2.20487 13.4568 2.109C13.4073 2.0838 13.3066 2.04613 13.0349 2.02393C12.7516 2.00078 12.3793 2 11.8028 2H8.86815C8.2916 2 7.91932 2.00078 7.63599 2.02393C7.36432 2.04613 7.2636 2.0838 7.21416 2.109C7.04196 2.19674 6.89922 2.33231 6.80276 2.49891H4.73303C4.77603 2.20725 4.85219 1.91856 4.99513 1.63803C5.28275 1.07355 5.74169 0.614605 6.30618 0.326985C6.68456 0.13419 7.07778 0.0628745 7.47312 0.0305735C7.84767 -2.81258e-05 8.30239 -1.47793e-05 8.82949 6.92431e-07H8.82953H8.82961ZM4.1999 3.4989L4.16136 3.4989H4.16136C3.63421 3.49889 3.17945 3.49887 2.80488 3.52947C2.40953 3.56178 2.01631 3.63309 1.63793 3.82589C1.07345 4.11351 0.614504 4.57245 0.326884 5.13693C0.13409 5.51531 0.0627738 5.90853 0.0304728 6.30388C-0.000130135 6.67844 -0.000115429 7.13319 -9.83815e-05 7.66032V7.66036V7.69891V11.801V11.8395V11.8395C-0.000115429 12.3667 -0.000130136 12.8214 0.0304728 13.196C0.0627738 13.5913 0.13409 13.9846 0.326884 14.3629C0.614504 14.9274 1.07345 15.3864 1.63793 15.674C2.01631 15.8668 2.40953 15.9381 2.80487 15.9704C3.17945 16.001 3.63422 16.001 4.16138 16.001H4.1999H7.13452H7.17304C7.7002 16.001 8.15497 16.001 8.52955 15.9704C8.9249 15.9381 9.31811 15.8668 9.69649 15.674C10.261 15.3864 10.7199 14.9274 11.0075 14.3629C11.2003 13.9846 11.2717 13.5913 11.304 13.196C11.3346 12.8214 11.3345 12.3667 11.3345 11.8395V11.8395V11.801V7.6989V7.66038V7.66035C11.3345 7.13321 11.3346 6.67845 11.304 6.30388C11.2717 5.90853 11.2003 5.51531 11.0075 5.13693C10.7199 4.57245 10.261 4.11351 9.69649 3.82589C9.31811 3.63309 8.9249 3.56178 8.52955 3.52947C8.15498 3.49887 7.70022 3.49889 7.17307 3.4989H7.17307L7.13452 3.4989H4.1999ZM2.54591 5.6079C2.59536 5.58271 2.69608 5.54503 2.96774 5.52283C3.25108 5.49968 3.62335 5.4989 4.1999 5.4989H7.13452C7.71108 5.4989 8.08335 5.49968 8.36669 5.52283C8.63835 5.54503 8.73907 5.58271 8.78851 5.6079C8.97668 5.70377 9.12966 5.85675 9.22553 6.04491C9.25072 6.09436 9.2884 6.19508 9.31059 6.46674C9.33375 6.75008 9.33452 7.12235 9.33452 7.6989V11.801C9.33452 12.3775 9.33375 12.7498 9.31059 13.0331C9.2884 13.3048 9.25072 13.4055 9.22553 13.4549C9.12966 13.6431 8.97668 13.7961 8.78851 13.892C8.73907 13.9172 8.63835 13.9548 8.36669 13.977C8.08335 14.0002 7.71108 14.001 7.13452 14.001H4.1999C3.62335 14.001 3.25108 14.0002 2.96774 13.977C2.69608 13.9548 2.59536 13.9172 2.54591 13.892C2.35775 13.7961 2.20477 13.6431 2.1089 13.4549C2.0837 13.4055 2.04603 13.3048 2.02383 13.0331C2.00068 12.7498 1.9999 12.3775 1.9999 11.801V7.69891C1.9999 7.12235 2.00068 6.75008 2.02383 6.46674C2.04603 6.19508 2.0837 6.09436 2.1089 6.04491C2.20477 5.85675 2.35775 5.70377 2.54591 5.6079Z" fill="currentColor"></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <p class="info__notification-alarm">当您的付款状态发生变化时，我们会向您发送通知<button class="notification-alarm__email">留下你的邮箱</button></p>
        </div>
      </div>
      <div class="checkout__status">
        <div class="status__expire">
          <expire-component :expirationTime="token.expirationTime"/>
        </div>
        <div class="status__confirms">
          <div class="confirm">
            <div class="confirm__icon">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.3152 1.64544C22.4189 0.823526 23.1709 0.235591 23.9827 0.400559C26.2534 0.861978 28.4269 1.71457 30.4057 2.92014C31.1132 3.35116 31.2649 4.2936 30.782 4.96678C30.2992 5.63997 29.365 5.78795 28.6519 5.36633C27.0865 4.44082 25.3827 3.77242 23.6055 3.38674C22.7959 3.21104 22.2115 2.46735 22.3152 1.64544Z" fill="#3AC270"></path>
                <path d="M32.4757 6.33955C33.0343 5.72784 33.9877 5.68115 34.5559 6.28408C36.145 7.97046 37.429 9.92035 38.3505 12.0464C38.6799 12.8065 38.2604 13.6639 37.4777 13.9355C36.6951 14.207 35.8465 13.7892 35.5071 13.0336C34.7619 11.3748 33.7552 9.84613 32.5257 8.50624C31.9656 7.89585 31.917 6.95127 32.4757 6.33955Z" fill="#3AC270"></path>
                <path d="M38.1403 16.3697C38.9526 16.2071 39.7489 16.7337 39.8501 17.5559C40.1333 19.8556 40.0146 22.1873 39.4995 24.4464C39.3153 25.2541 38.4697 25.6971 37.6781 25.4529C36.8865 25.2087 36.4497 24.3698 36.6231 23.5598C37.0039 21.7816 37.0969 19.9536 36.8986 18.146C36.8083 17.3225 37.328 16.5323 38.1403 16.3697Z" fill="#3AC270"></path>
                <path d="M36.6895 27.9819C37.4368 28.3394 37.7578 29.2384 37.3454 29.9568C35.8184 32.6169 33.6963 34.8964 31.1375 36.6119C28.1625 38.6065 24.7064 39.7656 21.1304 39.968C17.5543 40.1705 13.9895 39.4088 10.8084 37.7627C7.6273 36.1166 4.94663 33.6464 3.04645 30.6102C1.14627 27.574 0.0963298 24.0833 0.0063166 20.5026C-0.0836966 16.922 0.789523 13.3828 2.53474 10.255C4.27996 7.12717 6.83314 4.52541 9.92752 2.72154C12.5889 1.17007 15.5667 0.257801 18.6267 0.0471992C19.4531 -0.00968222 20.1214 0.671954 20.1162 1.50036C20.111 2.32878 19.434 2.98924 18.6083 3.05705C16.0862 3.26421 13.6355 4.03251 11.4384 5.31331C8.80817 6.8466 6.63797 9.0581 5.15453 11.7168C3.67109 14.3754 2.92886 17.3837 3.00537 20.4272C3.08188 23.4708 3.97433 26.4379 5.58948 29.0187C7.20463 31.5995 9.48321 33.6991 12.1872 35.0983C14.8911 36.4975 17.9212 37.1449 20.9608 36.9728C24.0005 36.8008 26.9381 35.8155 29.4669 34.1201C31.5792 32.7039 33.3415 30.8355 34.6303 28.6577C35.0522 27.9447 35.9421 27.6245 36.6895 27.9819Z" fill="#3AC270"></path>
              </svg>
            </div>
            <div class="confirm__text">
              <span class="text__title">确认</span>
              <p>0 来自 1</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button  class="btn" @click="this.$router.go(-1)" >取消</button>
    <div class="ContractAddress_contractAddressContainer" style="display: flex; overflow: hidden; height: auto; opacity: 1;">
      <h5 class="MuiTypography-root MuiTypography-body1 css-9l3uo3">合约地址:</h5>
      <a class="ContractAddress_contractAddressUrl__Z6uiY" :href=this.token.contract rel="noreferrer"
        target="_blank">
        <h5 class="MuiTypography-root MuiTypography-body1 ContractAddress_contractAddress__XzX1x css-9l3uo3">{{contract}}</h5>
      </a>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" triangleMobilePosition="20" trianglePosition="-3" dir="ltr" class="">
        <path d="M9.16504 8.6212C9.44483 8.01091 9.92016 7.51137 10.5158 7.20164C11.1115 6.8919 11.7934 6.78967 12.4537 6.91111C12.906 6.98051 13.3358 7.15501 13.7084 7.42059C14.0811 7.68616 14.3863 8.03542 14.5995 8.44032C14.753 8.76417 14.8363 9.11683 14.8438 9.47514C14.8514 9.83344 14.783 10.1893 14.6432 10.5193C14.5035 10.8493 14.2955 11.146 14.0329 11.3899C13.7703 11.6338 13.4591 11.8194 13.1197 11.9344C12.7734 12.0658 12.4739 12.2968 12.2588 12.5982C12.0437 12.8996 11.9227 13.258 11.9111 13.6281" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"></path>
        <path d="M11.8877 17.1387H11.8955" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M12 22C17.5229 22 22 17.5229 22 12C22 6.47716 17.5229 2 12 2C6.47716 2 2 6.47716 2 12C2 17.5229 6.47716 22 12 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>
    </div>
  </div>
</template>

<script>
import expireComponent from "@/components/crypto/expireComponent";
import QRCode from "qrcode";

export default {
  name: "checkOut",
  props:["token"],
  data(){
    return {
      code:false
    }
  },
  components:{
    expireComponent
  },
  methods:{
    copy(){
      this.$emit("copy", this.token.tokenAddress)
    },
    async generateQRCode() {
      try {
        // 获取 canvas 元素
        const canvas = this.$refs.qrcodeCanvas;
        // 调用 qrcode 生成二维码
        await QRCode.toCanvas(canvas, this.token.tokenAddress, {
          width: 200, // 二维码宽度
          margin: 1, // 边距
          color: {
            dark: "#000", // 二维码颜色
            light: "#fff", // 背景颜色
          },
        });
        this.code = true
      } catch (error) {
        console.error("二维码生成失败：", error);
      }
    },
    toggleQRCode() {
      if(this.code){
        this.code = false
      }

    }
  },
  computed:{
    contract(){
      const c = this.token.contract.split("/")
      const a = c[c.length-1]
      return `${a.slice(0, 3)}...${a.slice(-3)}`
    }
  }
}
</script>

<style scoped lang="scss">
.content__actions{
  background-color: #fff;
  border-radius: 0 0 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 32px;
  .checkout{
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 8px 16px #0000000a, 0 0 6px #0000000a;
    display: flex;
    flex-direction: column;
    width: 100%;
    .checkout__info{
      border-bottom: 1px solid #0000001a;
      display: flex;
      padding: 16px;
      .info__recipient{
        padding: 4px 0 0;
        width: 100%;
        .recipient__title{
          color: #747474;
          font-size: 14px;
          font-weight: 400;
          letter-spacing: -.08px;
          line-height: 20px;
          margin-bottom: 2px;
          text-align: start;
        }
        .recipient__address{
          rid-gap: 4px;
          display: grid;
          gap: 4px;
          grid-template-columns: minmax(100px, auto) 1fr;
          margin-bottom: 8px;
          .address__text{
            color: var(--contentPrimary);
            display: block;
            font-size: 16px;
            font-weight: 400;
            letter-spacing: -.12px;
            line-height: 24px;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .address__buttons{
            align-items: center;
            display: flex;
            gap: 8px;
            height: 24px;
            justify-content: flex-end;
            .address__copy_btn{
              align-items: center;
              background: none;
              border: none;
              color: var(--primary);
              display: flex;
              height: 24px;
              justify-content: center;
              padding: 0;
              width: 24px;
            }
          }
        }
        .info__notification-alarm{
          color: #747474;
          font-size: 14px;
          font-weight: 400;
          letter-spacing: -.08px;
          line-height: 20px;
          .notification-alarm__email{
            background: none;
            border: none;
            cursor: pointer;
            margin-bottom: 2px;
            outline: none;
            padding: 0;
            text-align: start;
            text-decoration: underline;
          }
        }
      }
    }
    .checkout__status{
      display: grid;
      grid-template-columns: 1fr;
      .status__expire{
        display: flex;
        border-bottom: 1px solid #0000001a;
        border-right: none;
        align-items: center;
      }
      .status__confirms{
        position: relative;
        .confirm{
          align-items: center;
          display: flex;
          flex-direction: row;
          justify-self: center;
          padding: 16px;
          .confirm__icon{
            align-items: center;
            animation-duration: 3s;
            animation-iteration-count: infinite;
            animation-name: ckw;
            color: #2aa668;
            display: flex;
            justify-content: center;
            margin-bottom: 0;
            margin-right: 16px;
            transform: rotate(180deg);
          }
          @keyframes ckw {
            0% {
              transform: rotate(0deg)
            }

            to {
              transform: rotate(1turn)
            }
          }
        }
        .confirm__text{
          color: #2aa668;
          font-size: 16px;
          font-weight: 600;
          line-height: 24px;
          max-width: 80%;
          overflow: hidden;
          text-align: start;
        }
        .text__title{
          color: #666;
          font-size: 16px;
          font-weight: 400;
          letter-spacing: -.12px;
          line-height: 24px;
        }
      }
    }
  }
}
.ContractAddress_contractAddressContainer{
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 16px #0000000a, 0 0 6px #0000000a;
  color: #666;
  display: flex;
  gap: 4px;
  padding: 16px;
  .css-9l3uo3{
    margin: 0px;
    font-family: Roboto, Helvetica, Arial, sans-serif;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5;
    letter-spacing: 0.00938em;
  }
  .ContractAddress_contractAddressUrl__Z6uiY{
    color: inherit;
    .ContractAddress_contractAddress__XzX1{
      cursor: pointer;
      text-decoration: underline;
      word-break: break-all;
    }
    .css-9l3uo3{
      margin: 0px;
      font-family: Roboto, Helvetica, Arial, sans-serif;
      font-weight: 400;
      font-size: 1rem;
      line-height: 1.5;
      letter-spacing: 0.00938em;
    }
  }
}
.AlternativePay_alternative_pay__6O8-y{
  display: flex;
  flex-direction: column;
  gap: 32px;
  .AlternativePay_alternative_pay_divider__YW2Tr{
    align-items: center;
    display: flex;
    gap: 32px;
    .AlternativePay_alternative_pay_divider_line__WkFis{
      border-top: 1px solid #0000001a;
      width: 100%;
    }
    p{
      color: #666;
    }

  }
  .AlternativePay_alternative_pay_btns__q4rMl{
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    width: 100%;
  }
}
.btn {
  height: 13.3vw;
  padding: 18px 24px;
  border-radius: 8px;
  border: none;
  font-size: 16px;
  font-weight: 400;
  justify-content: center;
  line-height: 20px;
  width: 100%;
  cursor: pointer;
  background-color: #000;
  color: #fff;
}
</style>
